export default __webpack_public_path__ + "assets/button.d44aefd9.svg";